export {
  ListItemComponent,
  ListItemInputAlignment,
  ListItemPadding,
  ListItemType,
} from './list-item.component';

// FIXME: T63333 Remove ListItemComponent
